/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'square-half': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8 15V1h6a1 1 0 011 1v12a1 1 0 01-1 1zm6 1a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v12a2 2 0 002 2z"/>',
    },
});
